import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import debug from '@/utils/debug';
import { useEffect, useState } from 'react';

export default function LockPeriods({ lockPeriods = [], onChange }) {
  const defaultValue = lockPeriods?.[0]?.value;
  const [lookPeriod, setLookPeriod] = useState(defaultValue);

  useEffect(() => {
    setLookPeriod(defaultValue);
    onChange(defaultValue);
  }, [lockPeriods, defaultValue]);

  if (!lockPeriods.length) return <></>;

  debug({ defaultValue, lockPeriods });

  return (
    <fieldset className='flex flex-col gap-4'>
      <RadioGroup
        className='grid grid-cols-2 md:grid-cols-4 gap-2'
        value={lookPeriod}
        onValueChange={value => {
          onChange(value);
          setLookPeriod(value);
        }}
      >
        {lockPeriods.map((item, index) => (
          <label
            key={index}
            className='relative flex cursor-pointer flex-col items-center gap-3 rounded-lg border border-white/10 px-2 py-3 text-center ring-offset-primary/5 transition-colors has-[[data-disabled]]:cursor-not-allowed has-[[data-state=checked]]:border-primary/10 has-[[data-state=checked]]:bg-primary/10 has-[[data-disabled]]:opacity-50 has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-ring/70 has-[:focus-visible]:ring-offset-2'
          >
            <RadioGroupItem
              id={item.value}
              value={item.value}
              className='sr-only after:absolute after:inset-0'
              aria-label={item.label}
            />
            <p className='text-sm font-medium leading-none text-foreground'>{item.label}</p>
          </label>
        ))}
      </RadioGroup>
    </fieldset>
  );
}
